export default __webpack_public_path__ + "static/media/icon-product-nooio-minisites.c8397d9b.svg";